import moment from "moment-timezone";
import { DAYS_IN_WEEK } from "@/constants";

export const REPEAT_OPTIONS = [
  { name: "zoom_meeting.weekly", value: "weekly" },
  { name: "zoom_meeting.daily", value: "daily" }
];
export const MEETING_TYPE = {
  schedule: "A schedule meeting",
  recurring: "A recurring meeting with fixed time"
};
export const TYPE_GUEST = {
  class: "class",
  user: "user-information"
};
export const JOIN_BEFORE_HOST = {
  anytime: "0",
  five: "5",
  ten: "10"
};
export const genWeeklyRepeatOn = (start, event) => {
  const { end, repeat_on } = event;
  const dayNumber = moment(end).diff(moment(start), "days") || 0;
  const isEditOldSchedule = !!repeat_on;
  let allowedRepeatDays = [];
  if (dayNumber >= 7) {
    allowedRepeatDays = DAYS_IN_WEEK;
  } else {
    const startDate = moment(start);

    while (startDate.isSameOrBefore(moment(end), "date")) {
      const dayObject = {
        label: startDate.format("ddd"),
        value: startDate.format("dddd")
      };
      allowedRepeatDays.push(dayObject);
      startDate.add(1, "days");
    }
  }

  return allowedRepeatDays.map(repeatObj => {
    const savedRepeat = isEditOldSchedule
      ? repeat_on.find(savedRepeat => savedRepeat.dayOfWeek === repeatObj.value)
      : null;
    if (!savedRepeat) {
      return {
        from_time: "",
        day_of_week: repeatObj.value,
        dayOfWeek: repeatObj
      };
    }

    return {
      ...savedRepeat,
      day_of_week: repeatObj.value,
      dayOfWeek: repeatObj
    };
  });
};
export const KEY_GENERATE_ZOOM = {
  form: [
    "id",
    "uuid",
    "title",
    "description",
    "password",
    "zoom_meeting_type",
    "duration",
    "timezone",
    "notification_before",
    "join_before_host",
    "participant_join_before_host",
    "repeat",
    "start",
    "end",
    "from_time"
  ]
};
